import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { getTooltipContent } from '@experiment-management-shared/utils';
import styles from './StatusConfigurationCell.module.scss';

function statusConfigurationToString(rowString) {
  if (!rowString) return '';

  let statusConfiguration = rowString;

  if (typeof rowString === 'string') {
    try {
      statusConfiguration = JSON.parse(rowString);
    } catch (error) {
      console.error('Failed to parse statusConfiguration', error);
      return '';
    }
  }

  return statusConfiguration
    .filter(item => item?.key?.trim?.() !== '')
    .map(item => {
      return `${item.key}: ${item.value}`;
    })
    .join(', ');
}

const StatusConfigurationCell = props => {
  const { row } = props;
  const statusConfiguration = row?.rowData?.statusConfiguration;

  return (
    <Tooltip
      arrow
      title={getTooltipContent({
        tooltipData: statusConfiguration
      })}
      placement="top"
      interactive={true}
    >
      <span className={styles.truncate}>
        {statusConfigurationToString(statusConfiguration)}
      </span>
    </Tooltip>
  );
};

export default StatusConfigurationCell;
